import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { FeaturesSection } from '../components/FeaturesSection';
import { ModulesSection } from '../components/ModulesSection';
import { BonusesSection } from '../components/BonusesSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { PricingSection } from '../components/PricingSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { TestimonialsBottom } from '../components/TestimonialsBottom';
import { FaqSection } from '../components/FaqSection';
import { FinalPricingCTA } from '../components/FinalPricingCTA';
import { Footer } from '../components/Footer';
import { StickyCTA } from '../components/StickyCTA';
export function Landing() {
  return <main className="min-h-screen bg-[#f8fafc]" data-id="element-188">
      <HeroSection data-id="element-189" />
      <ProblemSection data-id="element-190" />
      <div className="cv-section" data-id="element-191">
        <SolutionSection data-id="element-192" />
      </div>
      <div className="cv-section" data-id="element-193">
        <FeaturesSection data-id="element-194" />
      </div>
      <div className="cv-section" data-id="element-195">
        <ModulesSection data-id="element-196" />
      </div>
      <div className="cv-section" data-id="element-197">
        <BonusesSection data-id="element-198" />
      </div>
      <div className="cv-section" data-id="element-199">
        <BenefitsSection data-id="element-200" />
      </div>
      <PricingSection data-id="element-201" />
      <div className="cv-section" data-id="element-202">
        <GuaranteeSection data-id="element-203" />
      </div>
      <div className="cv-section" data-id="element-204">
        <TestimonialsBottom data-id="element-205" />
      </div>
      <div className="cv-section" data-id="element-206">
        <FaqSection data-id="element-207" />
      </div>
      <div className="cv-section" data-id="element-208">
        <FinalPricingCTA data-id="element-209" />
      </div>
      <Footer data-id="element-210" />
      <StickyCTA data-id="element-211" />
    </main>;
}